import { Info } from 'lucide-react';
import styled from 'styled-components';
import { cn } from '@shadcn/lib/utils';
import { MASKED_TEXT_CLASS } from 'analytics';

export const SectionWrapper = styled.div.attrs({
  className: 'mb-4',
})``;

export const SectionHeader = styled.div.attrs({
  className: 'mb-2 flex items-center justify-between',
})``;

export const SectionHeaderLeft = styled.div.attrs({
  className: 'flex items-center gap-2',
})``;

export const SectionTitle = styled.h2.attrs({
  className: 'text-sm font-medium text-foreground',
})``;

export const SectionActions = styled.div.attrs({
  className: 'flex space-x-3 items-center',
})``;

export const HintButton = styled.button.attrs({
  type: 'button',
  className: 'text-muted-foreground hover:text-foreground',
})``;

export const HintIcon = styled(Info).attrs({
  className: 'h-3.5 w-3.5',
})``;

export const AudioLevelIndicator = styled.div.attrs({
  'aria-label': 'Input level',
  title: 'Input level',
  className: 'flex items-end h-4 w-6 gap-[2px]',
})``;

export const AudioBar = styled.span.attrs({
  className: 'w-[3px] bg-success rounded-sm',
})``;

export const MicButton = styled.button.attrs({
  type: 'button',
  className: 'text-muted-foreground hover:text-foreground disabled:opacity-50',
})``;

export const MicOffButton = styled.button.attrs({
  type: 'button',
  className: 'text-red-600 hover:text-red-700',
})``;

export const CopyButton = styled.button.attrs({
  type: 'button',
  className: 'text-muted-foreground hover:text-foreground',
})``;

export const ContentWrapper = styled.div.attrs({
  className: 'relative',
})``;

export const EditorScope = styled.div`
  .tiptap p.is-editor-empty:first-child::before {
    content: attr(data-placeholder);
    color: var(--color-muted-foreground);
    pointer-events: none;
    float: left;
    height: 0;
  }
`;

export const NOTE_EDITOR_CLASS = cn(
  'tiptap',
  'border-input focus-visible:border-ring focus-visible:ring-ring/50',
  'dark:bg-input/30 w-full rounded-md border bg-transparent text-xs shadow-xs',
  'transition-[color,box-shadow] outline-none focus-visible:ring-[3px]',
  'p-2 pb-8 min-h-15',
  MASKED_TEXT_CLASS
);

export const AutoSaveIndicator = styled.span.attrs({
  title: 'Autosaved',
  className:
    'absolute bottom-2 right-2 text-success flex items-center gap-1 text-xs bg-background/80 rounded px-1 py-0.5',
})``;
